import { LinePosition } from "./types";

function join(a: LinePosition, b: LinePosition): `${LinePosition}/${LinePosition}` {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return (a + "/" + b) as any;
}

export function getVisibility(
  sections: Array<unknown>,
  tops: Map<number, LinePosition>,
  bottoms: Map<number, LinePosition>,
) {
  return sections.map((section, idx) => {
    const t = tops.get(idx);
    const b = bottoms.get(idx);

    if (!t || !b) {
      return {
        tag: "not-visible" as const,
        isVisible: false,
      };
    }

    const status = join(t, b);

    switch (status) {
      case "above/above": {
        return {
          tag: "fully-above" as const,
          isVisible: false,
          canTopBeSeen: t === "visible",
        };
      }
      case "above/visible": {
        return {
          tag: "leaving-but-visible" as const,
          isVisible: true,
          canTopBeSeen: t === "visible",
        };
      }
      case "above/below": {
        return {
          tag: "visible-higher-than-viewport" as const,
          isVisible: true,
          canTopBeSeen: t === "visible",
        };
      }

      case "visible/above": {
        return {
          tag: "visible" as const,
          isVisible: true,
          canTopBeSeen: t === "visible",
        };
      }
      case "visible/visible": {
        return {
          tag: "fully-visible" as const,
          isVisible: true,
          canTopBeSeen: t === "visible",
        };
      }
      case "visible/below": {
        return {
          tag: "visible" as const,
          isVisible: true,
          canTopBeSeen: t === "visible",
        };
      }

      case "below/above": {
        return {
          tag: "not-visible" as const,
          isVisible: false,
          canTopBeSeen: t === "visible",
        };
      }
      case "below/visible": {
        return {
          tag: "not-visible" as const,
          isVisible: false,
          canTopBeSeen: t === "visible",
        };
      }
      case "below/below": {
        return {
          tag: "not-visible" as const,
          isVisible: false,
          canTopBeSeen: t === "visible",
        };
      }
    }
  });
}

export type Visibility = ReturnType<typeof getVisibility>[0];
